// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"iu","contentFrame":"iv","buttonGroup":"iw","button":"ix","header":"iy","text":"iz","contentImage":"iA","closeButton":"iB"};